import {hasOwnProperty} from './utils';
import {setErrors} from './status/actions';
import {executeFetch} from './fetch';
import * as querystring from 'querystring';


export class Api {
  csrfToken = () => {
    return document.querySelector("meta[name='csrf-token']").getAttribute("content");
  }

  handleErrors = (data, id, dispatch) => {
    if (hasOwnProperty(data, 'errors')) {
      dispatch(setErrors(id, data.errors));
      return true;
    }
    return false;
  }

  index = (data) => {
    let items = new Map();
    data.data.forEach((item) => {
      items.set(item.id, item);
    });

    return items;
  }

  post = async (url, object = null) => {
    return await this.request(url, null, 'POST', object);
  }

  request = async (path, queryParams = null, method = null, object = null) => {
    let url = new URL(path, window.location);
    if (queryParams != null) {
      url.search = querystring.stringify(queryParams);
    }
    let options = {
      credentials: 'same-origin',
      headers: new Headers({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken(),
      }),
    };
    if (object != null) {
      options.body = JSON.stringify(object);      
    }
    if (method != null) {
      options.method = method;
    }
    let request = new Request(url, options);
    return await executeFetch(request);
  }
}
